import { memberMobx, payPlanMobx } from '@mobxStore'
import { makeAutoObservable } from 'mobx'
import { toDecimal } from '@dt/fe-utils'

class PayRecharge {
  constructor () {
    makeAutoObservable(this)
  }

  // 支付信息
  payInfo: any

  // 充值信息
  rechargeInfo: any

  // 虚拟订单信息
  virtualOrder: any

  // 缓存充值信息
  cacheRechargeInfo: any

  // 会员卡是否能全额支付
  get memberCardCanFullpay () {
    const balance = memberMobx.cardInfo?.balance || 0
    const orderAmount = payPlanMobx.orderAmount || 0
    const payAmount = payPlanMobx?.memberCardMethod?.amount || 0
    return !this.rechargeInfo && !!payAmount && (balance >= orderAmount || orderAmount === payAmount)
  }

  get memberCardDiscountOnlyBalancePay () {
    return memberMobx.cardInfo?.card?.extra?.balanceDiscountRule === 'onlyBalancePay'
  }

  get memberCardBalanceAfterRecharge () {
    return toDecimal((memberMobx.cardInfo?.balance || 0) + (this.rechargeInfo?.money || 0) + (this.rechargeInfo?.moneyGive || 0) - payPlanMobx.totalAmount, 2)
  }

  isReset (info?: any) {
    return this.cacheRechargeInfo?.cardId !== info?.cardId || this.cacheRechargeInfo?.cardRechargeId !== info?.cardRechargeId
  }

  setPayInfo (info?: any) {
    this.payInfo = info
  }

  setRechargeInfo (info?: any) {
    this.rechargeInfo = info
  }

  setVirtualOrder (info) {
    this.virtualOrder = info
  }

  setCacheRechargeInfo (info?: any) {
    if (this.isReset(info)) {
      this.cacheRechargeInfo = info
    }
  }

  reset () {
    this.payInfo = null
    this.rechargeInfo = null
    this.virtualOrder = null
    this.cacheRechargeInfo = null
  }
}

export default new PayRecharge()
